import { ContentWorkflow } from '@amzn/awscat-pattern-library-service-model';

import { useLoadedDocument } from './useLoadedDocument';

/**
 * Subscribes to the {@link ContentEditorService} and returns the current
 * workflow (for draft documents). Returns undefined while no document is
 * loaded or when viewing a publication.
 */
export function useWorkflow(): ContentWorkflow | undefined {
  const doc = useLoadedDocument();

  // Only drafts and finalizing workspaces carry a workflow.
  return doc?.kind === 'draft' || doc?.kind === 'finalizing' ? doc.workflow : undefined;
}
